import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectGamePlayer, selectPrizePile } from '../ActiveGame/selectors';
import { selectCurrentUser } from '../Login/selectors';
import ConfirmButton from '../ConfirmButton';
import CardFace from '../Card/CardFace';
import { drawPrize } from './actions';
import { selectDrawing } from './selectors';

/** One of the six prize spots, at `position` 0–5. Prizes stay face down until taken. */
const PrizeSlot = ({ userId, position }) => {
  const dispatch = useDispatch();
  const drawing = useSelector(selectDrawing);
  const gamePlayer = useSelector((state) => selectGamePlayer(state, { userId }));
  const isMine = useSelector(selectCurrentUser).get('id') === userId;
  const prizePile = useSelector((state) => selectPrizePile(state, { userId }));

  const prize = prizePile && prizePile.get('cards').find(card => card.get('order') === position);

  if (!prize) {
    return null;
  }

  // gamePlayer.prizes is how many prize cards this player has earned and not yet taken. It can be owed on either
  // player's turn, since poison knocks Pokémon out between turns.
  if (isMine && gamePlayer && gamePlayer.get('prizes') > 0) {
    return (
      <ConfirmButton
        onConfirm={() => dispatch(drawPrize(position))}
        disabled={drawing}
        prompt="Take this prize card?"
        plain
      >
        <CardFace label="Prize card" targetable={!drawing} />
      </ConfirmButton>
    );
  }

  return <CardFace label="Prize card" />;
};

PrizeSlot.propTypes = {
  userId: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
};

export default PrizeSlot;
